import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from '@/components/Dashboard.vue';
import Settings from '@/components/Settings.vue';
import Account from '@/components/Account.vue';
import Login from '@/components/Login.vue';
import Registration from '@/components/Registration.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import VerifyEmail from '@/components/VerifyEmail.vue';
import OAuthCallback from '@/components/OAuthCallback.vue';
import ExtensionCallback from '@/components/ExtensionCallback.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import Support from '@/components/Support.vue';
import AdminAnalytics from '@/components/AdminAnalytics.vue';
import LandingPage from '@/components/LandingPage.vue';
import store from '@/store';

// Define the routes
const routes = [
  { path: '/', component: LandingPage },
  { path: '/dashboard', component: Dashboard, requiresAuth: true },
  { path: '/settings', component: Settings, requiresAuth: true },
  { path: '/account', component: Account, requiresAuth: true },
  { path: '/login', component: Login },
  { path: '/registration', component: Registration },
  { path: '/reset-password', component: ResetPassword },
  { path: '/verify-email', component: VerifyEmail },
  { path: '/oauth/callback', component: OAuthCallback },
  { path: '/extension/callback', component: ExtensionCallback },
  { path: '/privacy', component: PrivacyPolicy },
  { path: '/terms', component: TermsOfService },
  { path: '/support', component: Support },
  { path: '/admin/analytics', component: AdminAnalytics, requiresAuth: true, requiresAdmin: true },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(), // Use HTML5 history mode (no hash in URL)
  routes
});

// Add a global navigation guard to handle authentication and proactive token refresh
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const isTokenExpiringSoon = store.getters['auth/isTokenExpiringSoon'];

  // Public routes that don't require authentication
  const publicRoutes = ['/', '/login', '/registration', '/verify-email', '/reset-password', '/oauth/callback', '/extension/callback', '/privacy', '/terms', '/support'];
  const isPublicRoute = publicRoutes.includes(to.path);

  if (!isAuthenticated && !isPublicRoute) {
    next('/login');
    return;
  }

  if (to.meta.requiresAdmin && !store.getters['auth/isAdmin']) {
    next('/dashboard');
    return;
  }
  if (isAuthenticated && (to.path === '/login' || to.path === '/registration' || to.path === '/')) {
    next('/dashboard');
    return;
  }

  // Proactive refresh: if token expires within 24h, refresh before continuing
  if (isAuthenticated && isTokenExpiringSoon) {
    try {
      await store.dispatch('auth/refreshToken');
    } catch (_) {
      store.dispatch('auth/logout');
      next('/login');
      return;
    }
  }

  next();
});

export default router;
